export const Scopes = {
  ME: "me",
  USERS_WRITE: "users:write",
  USERS_READ: "users:read",
  MERCHANTS_WRITE: "merchants:write",
  MERCHANTS_READ: "merchants:read",
  MERCHANTS_WRITE_ALL: "merchants:write-all",
  MERCHANTS_READ_ALL: "merchants:read-all",
  MERCHANTS_USERS_WRITE: "merchants-users:write",
  MERCHANTS_USERS_READ: "merchants-users:read",
  CITIES_WRITE: "cities:write",
  CITIES_READ: "cities:read",
  SERVICES_WRITE: "services:write",
  SERVICES_READ: "services:read",
  CUSTOMERS_USERS_WRITE: "customers-users:write",
  CUSTOMERS_USERS_READ: "customers-users:read",
  CUSTOMERS_VEHICLES_TRIMS_MAKES_MODELS_READ: "customers-vehicles-trims-makes-models:read",
  CUSTOMERS_VEHICLES_TRIMS_MAKES_MODELS_WRITE: "customers-vehicles-trims-makes-models:write",
  CUSTOMERS_VEHICLES_READ: "customers-vehicles:read",
  CUSTOMERS_VEHICLES_WRITE: "customers-vehicles:write",
  MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_READ: "merchants-branches-appointments-settings:read",
  MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_WRITE: "merchants-branches-appointments-settings:write",
  MERCHANTS_BRANCHES_APPOINTMENTS_READ: "merchants-branches-appointments:read",
  MERCHANTS_BRANCHES_APPOINTMENTS_WRITE: "merchants-branches-appointments:write",
  MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_READ: "merchants-branches-appointments-bookings:read",
  MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_WRITE: "merchants-branches-appointments-bookings:write",
  MERCHANTS_BRANCHES_WRITE: "merchants-branches:write",
  MERCHANTS_BRANCHES_READ: "merchants-branches:read",
  MERCHANTS_BRANCHES_OFFERS_READ: "merchants-branches-offers:read",
  MERCHANTS_BRANCHES_OFFERS_WRITE: "merchants-branches-offers:write",
  MERCHANTS_WORKERS_READ: "merchants-workers:read",
  MERCHANTS_WORKERS_WRITE: "merchants-workers:write",
  MERCHANTS_ITEMS_READ: "merchants-items:read",
  MERCHANTS_ITEMS_WRITE: "merchants-items:write",
  MERCHANTS_SUBITEMS_READ: "merchants-subitems:read",
  MERCHANTS_SUBITEMS_WRITE: "merchants-subitems:write",
  MERCHANTS_JOBS_READ: "merchants-jobs:read",
  MERCHANTS_JOBS_WRITE: "merchants-jobs:write",
  MERCHANTS_BRANCHES_SERVICES_READ: "merchants-branches-services:read",
  MERCHANTS_BRANCHES_SERVICES_WRITE: "merchants-branches-services:write",
  MERCHANTS_BRANCHES_PHOTOS_READ: "merchants-branches-photos:read",
  MERCHANTS_BRANCHES_PHOTOS_WRITE: "merchants-branches-photos:write",
  VEHICLES_MAKES_READ: "vehicles-makes:read",
  VEHICLES_MAKES_WRITE: "vehicles-makes:write",
  NOTIFICATIONS_READ: "notifications:read",
  NOTIFICATIONS_WRITE: "notifications:write",
  BANNERS_READ: "banners:read",
  BANNERS_WRITE: "banners:write",
  OFFERS_READ: "offers:read",
  OFFERS_WRITE: "offers:write",
  MERCHANTS_BRANCHES_RATINGS_READ: "merchants-branches-ratings:read",
  MERCHANTS_BRANCHES_RATINGS_WRITE: "merchants-branches-ratings:write",
  WORK_ORDERS_READ: "work-orders:read",
  WORK_ORDERS_WRITE: "work-orders:write",
  GARAGE_SETUP_READ: "garage-setup:read",
  GARAGE_SETUP_WRITE: "garage-setup:write",
  PAYMENT_METHODS_READ: "payment-methods:read",
  PAYMENT_METHODS_WRITE: "payment-methods:write",
  CURRENCIES_READ: "currencies:read",
  CURRENCIES_WRITE: "currencies:write",
  DELIVERY_METHODS_READ: "delivery-methods:read",
  DELIVERY_METHODS_WRITE: "delivery-methods:write",
}
